// src\themes\default\elements\Header\MainContentWrapper.tsx
'use client';

import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { cn } from '@/core/lib/utils';

type MainContentWrapperProps = {
    children: ReactNode;
};

export default function MainContentWrapper({ children }: MainContentWrapperProps) {
    const pathname = usePathname();
    const isHome = /^\/[a-z]{2}\/?$/.test(pathname) || pathname === '/';

    return (
        <div className={cn('min-h-full', !isHome && 'pt-18')}>
            {children}
        </div>
    );
}